export const INPUT_TYPES = ['text', 'choice', 'audio', 'audio_transcript', 'image', 'video', 'file', 'drawing', 'game_action'];
export const OUTPUT_TYPES = ['text', 'buddy_reaction', 'choices', 'audio', 'image', 'video', 'file', 'story', 'game_state', 'music', 'activity', 'actions', 'progress', 'error'];

export const ACTIVITY_REGISTRY = {
  free_talk: {
    label: 'Talk', acceptedInputs: ['text', 'choice', 'audio_transcript'],
    outputTypes: ['text', 'buddy_reaction', 'choices'],
  },
  creative_drawing: {
    label: 'Draw', acceptedInputs: ['text', 'choice', 'audio_transcript', 'image'],
    outputTypes: ['text', 'buddy_reaction', 'image', 'actions'],
  },
  photo_story: {
    label: 'Photo Story', acceptedInputs: ['text', 'choice', 'audio_transcript', 'image'],
    outputTypes: ['text', 'buddy_reaction', 'image', 'story', 'file', 'audio', 'actions'],
  },
  scenario_talk: {
    label: 'Scenario Practice', acceptedInputs: ['text', 'choice', 'audio_transcript'],
    outputTypes: ['text', 'choices', 'actions'],
  },
};

export const createTurnPart = (type, content = {}, extra = {}) => ({
  id: window.crypto?.randomUUID?.() || `part-${Date.now()}-${Math.random()}`,
  type, content, status: 'ready', ...extra,
});

export const getActivityConfig = (activity) => ACTIVITY_REGISTRY[activity] || {
  label: activity, acceptedInputs: ['text'], outputTypes: ['text'],
};
